"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function gte(a, b) {
    if (b === undefined) {
        return function (_b) { return gte(a, _b); };
    }
    if (a.constructor !== b.constructor) {
        throw new TypeError("The values you want to compare must be of the same type");
    }
    return a >= b;
}
exports.default = gte;
//# sourceMappingURL=gte.js.map